import styled from 'styled-components';

export const ToastIconImg = styled.img`
  max-width: 100%;
  height: auto;
  object-fit: contain;
  object-position: center;
`;
